// assets/benefits-5-cards-toggle.js
(() => {
  const SELECTOR_SECTION = ".benefits-5";
  const SELECTOR_GRID = "[data-cards-grid]";
  const SELECTOR_CARD = "[data-card]";
  const MOBILE_MAX = 989;

  const isMobile = () =>
    window.matchMedia(`(max-width: ${MOBILE_MAX}px)`).matches;

  function setOpen(cardEl, open) {
    cardEl.classList.toggle("is-open", !!open);
    cardEl.setAttribute("aria-expanded", open ? "true" : "false");
  }

  function wireSection(sectionEl) {
    const grid = sectionEl.querySelector(SELECTOR_GRID);
    if (!grid) return;

    const cards = Array.from(grid.querySelectorAll(SELECTOR_CARD));
    if (!cards.length) return;

    // Limpia listeners previos
    if (sectionEl.__benefitsToggleCleanup) sectionEl.__benefitsToggleCleanup();

    const cleanups = [];

    const applyMobileAlwaysOpen = () => {
      cards.forEach((card) => {
        setOpen(card, true);
        // opcional: limpiar atributos de "button"
        card.removeAttribute("role");
        card.removeAttribute("tabindex");
      });

      // Si Flickity está activo, recalcula (por alturas)
      if (sectionEl.__benefitsFlickity) {
        sectionEl.__benefitsFlickity.resize();
        sectionEl.__benefitsFlickity.reposition();
      }
    };

    const bindDesktopHover = () => {
      cards.forEach((card) => {
        // En desktop parte cerrada por defecto (si quieres)
        setOpen(card, false);

        const onEnter = () => setOpen(card, true);
        const onLeave = () => setOpen(card, false);

        card.addEventListener("mouseenter", onEnter);
        card.addEventListener("mouseleave", onLeave);

        cleanups.push(() => {
          card.removeEventListener("mouseenter", onEnter);
          card.removeEventListener("mouseleave", onLeave);
        });
      });
    };

    const applyMode = () => {
      // limpia listeners anteriores
      cleanups.splice(0).forEach((fn) => fn);

      if (isMobile()) applyMobileAlwaysOpen();
      else bindDesktopHover();
    };

    applyMode();

    // Re-aplica en resize (por si cambias breakpoint)
    let t = null;
    const onResize = () => {
      clearTimeout(t);
      t = setTimeout(applyMode, 150);
    };

    window.addEventListener("resize", onResize);
    cleanups.push(() => window.removeEventListener("resize", onResize));

    sectionEl.__benefitsToggleCleanup = () => {
      cleanups.splice(0).forEach((fn) => fn);
      sectionEl.__benefitsToggleCleanup = null;
    };
  }

  function boot() {
    document.querySelectorAll(SELECTOR_SECTION).forEach(wireSection);
  }

  document.addEventListener("DOMContentLoaded", boot);

  document.addEventListener("shopify:section:load", (e) => {
    const sectionEl = e.target;
    if (sectionEl && sectionEl.matches && sectionEl.matches(SELECTOR_SECTION)) {
      wireSection(sectionEl);
    }
  });
})();